/* @flow */
import { setServiceUnavailable } from 'lib/retryLaterHelper';

export type ResponseInterceptorType = (response: Object, endpoint: string) => boolean;

// interceptor can prevent propagation to the next handler.
// if propagation is prevented then the promise will never
// be resolve (see apiRequest).

const PREVENT_PROPAGATION = true;
const CONTINUE_PROPAGATION = false;

export function serviceUnavailableInterceptor(response: Object, endpoint: string) {
  if (response.statusCode === 503) {
    setServiceUnavailable(response, endpoint);
  }

  // always continue propagation, because we want the
  // application to handle the failed request, and not
  // show loading indicators forever.
  return CONTINUE_PROPAGATION;
}

export function unauthorizedInterceptor(response: Object): boolean {
  if (response.statusCode === 401) {
    const { logIfUnexpected401 } = require('lib/WindowUser');
    const AuthActions = require('auth/AuthActions').default;

    logIfUnexpected401();
    AuthActions.expireSession();

    // AuthActions.expireSession does a hard redirect
    // we stop any propagation since it doesn't matter
    // and can even be harmfull.
    return PREVENT_PROPAGATION;
  }

  return CONTINUE_PROPAGATION;
}
